<template lang="pug">
.bloco-selecao-cultura(@click='dispararClickRadioButtonFiltro(icone)')
    .bloco-selecao-cultura-main-container
        .container-img
            img(:src='buscarUrlIcone(icone)')
        div(style='min-width: 80%')
            .bloco-selecao-cultura__titulo
                .bloco-selecao-cultura__titulo-interno
                    span {{ titulo }}
                .bloco-selecao-cultura__titulo-icone
                    slot

            .bloco-selecao-cultura__interno
                .bloco-selecao-cultura__interno-alinhamento
                    span.bloco-selecao-cultura__interno-normal {{ $t('mensagens.inteligenciaTerritorial.areaPlantada') }}:
                    span.bloco-selecao-cultura__interno-verde {{ formatNumber(totalAreaPlantada) }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'FiltroSelecaoCultura',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        totalAreaPlantada: {
            type: Number,
            default: 0
        },
        icone: {
            type: String,
            default: () => ''
        },
        estaSelecionado: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: false
        };
    },
    methods: {
        buscarUrlIcone(nome) {
            if (!this.estaSelecionado) {
                return require(`@/assets/lyra-icons/culturas/${nome}.svg`);
            } else {
                return require(`@/assets/lyra-icons/culturas/${nome}-selecionado.svg`);
            }
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 0) + ' ha';
        },
        dispararClickRadioButtonFiltro(botao) {
            const btnNome = this.capitalizeFirstLetter(botao);
            document.querySelector('#culturaSelecionada' + btnNome).click();
        },
        capitalizeFirstLetter(str) {
            if (typeof str !== 'string' || str.length === 0) {
                return str;
            }

            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-selecao-cultura {
    min-width: 24%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    flex-wrap: wrap;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 15px 20px;
    flex-direction: column;
    cursor: pointer;

    .bloco-selecao-cultura-main-container {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }
    .bloco-selecao-cultura__titulo {
        display: flex;
        justify-content: space-between;
        align-self: normal;
    }
    .bloco-selecao-cultura__titulo-interno {
        width: 90%;
        font-size: 18px;
        font-weight: 500;
        display: flex;
    }
    .bloco-selecao-cultura__titulo-icone {
        width: 10%;
        font-size: 22px;
        display: flex;
        align-items: center;
    }
    .bloco-selecao-cultura__interno {
        margin-right: 3px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 90%;
        .bloco-selecao-cultura__interno-alinhamento {
            display: flex;
        }
    }

    .bloco-selecao-cultura__titulo
        > div.bloco-selecao-cultura__titulo-icone
        > label
        > span.el-radio__label {
        display: none;
    }
    .bloco-selecao-cultura__interno-dados {
        flex-wrap: wrap;
        font-size: 20px;
    }
    span {
        &.bloco-selecao-cultura__interno-valor {
            max-width: 184px;
            font-weight: 600;
            font-size: 18px;
            padding: 0px;
        }

        &.bloco-selecao-cultura__interno-normal {
            font-weight: 300;
        }
        &.bloco-selecao-cultura__interno-verde {
            font-weight: 600;
            margin-left: 3px;
            font-size: 14px;
            color: var(--primary);
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
    .container-img {
        align-self: center;
        min-width: 10%;
    }
}
.filtro-cultura-ativada {
    border-left: solid var(--secondary-two) 15px;
    .bloco-selecao-cultura__titulo-interno {
        color: var(--secondary-two) !important;
    }
    .bloco-selecao-cultura__titulo-icone {
        color: var(--secondary-two);
    }
    .bloco-selecao-cultura__interno-verde {
        color: var(--secondary-two) !important;
    }
}
.filtro-cultura-desativada {
    border-left: solid var(--background-disabled) 15px;
}

@media (max-width: 1440px) {
    .bloco-selecao-cultura-main-container {
        gap: 15px;
        justify-content: space-between;
    }
    .bloco-selecao-cultura .container-img {
        align-self: center;
        min-width: 15%;
    }
}
</style>
